import { render } from "./rectorStudioManager.vue?vue&type=template&id=a57b3d74&scoped=true"
import script from "./rectorStudioManager.vue?vue&type=script&lang=js"
export * from "./rectorStudioManager.vue?vue&type=script&lang=js"

import "./rectorStudioManager.vue?vue&type=style&index=0&id=a57b3d74&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a57b3d74"]])

export default __exports__